var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activator-wrapper"},[_c('input',_vm._b({staticClass:"text-field",class:_vm.inputClass,attrs:{"type":"text"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false)),(_vm.picker.showActivatorBar)?_c('span',{staticClass:"bar"}):_vm._e(),(_vm.picker.showActivatorLabel)?_c('label',[_vm._v("Select Date")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }